import { DefaultProductOptions } from '../analytics-context-types';
import { getPODModalTag, getPODProductTag } from './utils';

export const getUSPSValidationManualAddressReturnOrRecipientTag = ({
  options,
}: {
  options: DefaultProductOptions & {
    addressType: 'return' | 'recipient';
    action: 'x' | 'edit address' | 'confirm address' | 'close';
  };
}) => {
  const level2Type = options.addressType.charAt(0).toUpperCase() + options.addressType.slice(1);
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );
  const event = [
    {
      eventInfo: {
        eventName: `${options.addressType} address`,
        eventAction: 'manual add address',
      },
    },
    {
      eventInfo: {
        eventName: 'invalid address',
        eventAction: options.action,
      },
    },
  ];

  const { modal, user } = getPODModalTag(`Address the Envelope - ${level2Type}`, event, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
